import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import {
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType,
} from "react-router-dom";
import config from './config';

if (config.environment !== 'dev') Sentry.init({
    dsn: "https://71e3ae061d924a74be5bbed789217abf@o369240.ingest.sentry.io/5691134",
    environment: config.environment,
    release: "app-file-converter@" + APP_VERSION,
    integrations: [
        // See docs for support of different versions of variation of react router
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
        Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
        }),
        Sentry.replayIntegration(),
    ],
    tracesSampleRate: config.environment === 'production' ? 0.1 : 1
});